// This file is only a template for constants.  Copy and paste this to your application's constants .ts file and start off from there
// Rename all things with App_Name.
// Naming convention for constants is "[App Name]Constants.ts" i.e. UsersConstants.ts, EntitlementConstants.ts

// convention for constants is
// [App_Name]_[Action]

export default {
    Viewer3DConstants: {
        VIEWER_GRAPHICS_GET: 'VIEWER_GRAPHICS_GET',
        APPEARANCES_LOADING: 'APPEARANCES_LOADING',
        APPEARANCES_GET_ALL: 'APPEARANCES_GET_ALL'
    },

    ViewerSettingValuesEnum: {
        Fit: 'Fit',
        Fill: 'Fill',
        Show: 'Show',
        Hide: 'Hide',
    },

    ViewerMemoryLevelValuesEnum: {
        Recommended: 'Recommended',
        Maximum: 'Maximum'
    },

    Viewer3DSettingsEnums: {
        CanvasMargin: 'CanvasMargin',
        Compass: 'Compass',
        Shader: 'Shader',
        Ridge: 'Ridge',
        Valley: 'Valley',
        AmbientIntensity: 'AmbientIntensity',
        Slider: 'Slider',
        MemoryLinit: 'MemoryLimit',
        MemoryLevel: 'MemoryLevel',
        LightingMode: 'LightingMode',
        BackgroundColor: 'BackgroundColor',
        MeasurementColor: 'MeasurementColor',
        TagVolumeBoxColor: 'TagVolumeBoxColor',
        PanoScanSphereColor: 'PanoScanSphereColor',
        PanoImageSphereColor: 'PanoImageSphereColor',
        MemoryProfile: "MemoryProfile",
        MeshResolution: "MeshResolution",
        CameraTypeExamine: "CameraExamine",
        CameraTypeUniversal: "CameraUniversal",
        CameraTypeFly: "CameraFly",
        CameraType: "CameraType",
        ShowCrosshair: "ShowCrosshair",
        RotationSensitivity: "RotationSensitivity",
        VelocitySensitivity: "VelocitySensitivity",
        InvertY: "InvertY"
    }
};
